import React from 'react';

export default function Button(props) {
    return (
        <div className={"button " + `${props.buttonsize}`}>
            <a id={props.buttonID} href={props.buttonsource} onClick={props.buttononclick} target={props.buttontarget}>
                <h3>{props.buttonname}</h3>
            </a>
        </div>
    )
}